import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  #http = inject(HttpClient);
  #oidcSecurityService = inject(OidcSecurityService);

  // TODO : Implement security logic

  getUserData(): Observable<UserDataResult> {
    return this.#oidcSecurityService.userData$;
  }

  isLoggedIn(): Observable<boolean> {
    return this.#oidcSecurityService.isAuthenticated();
  }

  login() {
    this.#oidcSecurityService.authorize();
  }

  logout() {
    this.#oidcSecurityService.logoffAndRevokeTokens().subscribe();
  }

  changePassword() {
    // TODO : something.changePassword();
  }

  getUserToken(): Observable<string> {
    return this.#oidcSecurityService.getAccessToken();
  }

  roleAppManager() {
    // TODO : return something.hasRealmRole('app-manager')
  }

  /**
   * Sends an HTTP POST request to register the provided user information.
   *
   * @param {Object} dataRegistration - The registration data to be sent in the POST request.
   * @returns {Observable<unknown>} An observable containing the API response after sending the registration email.
   */
  registration(dataRegistration: {
    firstName: string;
    lastName: string;
    company: string;
    email: string;
  }): Observable<unknown> {
    // TODO : change unknown by model
    return this.#http.post<unknown>(environment.businessBaseUrl + '/send-mail', dataRegistration);
  }

  /**
   * Sends an HTTP POST request to launch the retreive password process.
   *
   * @param {Object} dataRegistration - The registration data to be sent in the POST request.
   * @returns {Observable<unknown>} An observable containing the API response after sending the registration email.
   */
  passwordForgotten(dataRegistration: { firstName: string; lastName: string; company: string; email: string }) {
    // TODO : change unknown by model
    return this.#http.post<unknown>(environment.businessBaseUrl + '/password-forgotten', dataRegistration);
  }
}
